import { connect } from 'react-redux'
import ActivateStudent from 'modules/Onboarding/Components/ActivateAccount/index'
import selectors from 'modules/Onboarding/selectors'
import {
  getStudentData,
  getCollege,
  sendOtp,
  getListOfSkills,
  updateStudentData,
  checkOtp,
  resetPwd,
  updateCurrentState,
  updateStatusPending
} from 'modules/Onboarding/actions'

const mapStateToProps = state => ({
  studentDetails: selectors.getStudentDetails(state),
  campusDetails: selectors.getCampuDetails(state),
  studentEditData: selectors.getStudentEditData(state),
  listOfSkills: selectors.getListOfSkills(state),

})

const mapDispatchToProps = {
  getStudentData,
  getCollege,
  sendOtp,
  getListOfSkills,
  updateStudentData,
  checkOtp,
  resetPwd,
  updateCurrentState,
  updateStatusPending
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivateStudent)
